import { render, staticRenderFns } from "./Auto_Services.vue?vue&type=template&id=22f8730b&scoped=true"
import script from "./Auto_Services.vue?vue&type=script&lang=js"
export * from "./Auto_Services.vue?vue&type=script&lang=js"
import style0 from "./Auto_Services.vue?vue&type=style&index=0&id=22f8730b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f8730b",
  null
  
)

export default component.exports